import { callApi } from "@/api/api-core";

export const listIdTypes = function(ownerHandlesFailure) {
    return callApi(
        "POST",
        "v2/identification/card/types/anonymouscustomer",
        null,
        ownerHandlesFailure
    );
};
